<div class="modal-content">
  <div class="modal-header">
      EDITAR INFORMAÇÕES DO BANNER DO APLICATIVO
      <img src="./assets/icon_custom/18-p-fechar-b.svg" class="close-btn" (click)="closeModal()">
  </div>
  <div class="modal-body">
      <app-app-banners-form [appBannerToEdit]="data.bannerToEdit" (appBannerEmitter)="editBanner($event)"></app-app-banners-form>
  </div>
</div>
